
import { Outlet, Link, useLocation } from "react-router-dom";
import { Flame, Users, UploadCloud, LayoutDashboard, Menu, X, User, Settings } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
    { name: "Lead Upload", href: "/leads/upload", icon: UploadCloud },
    { name: "Admin", href: "/admin", icon: Settings },
  ];

  return (
    <div className="h-full flex">
      {/* Mobile sidebar overlay */}
      <div className={cn(
        "fixed inset-0 z-40 bg-background/80 backdrop-blur-sm transition-opacity duration-300",
        sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      )} 
      onClick={() => setSidebarOpen(false)} />

      {/* Mobile sidebar */}
      <div className={cn(
        "fixed inset-y-0 left-0 z-50 w-72 bg-white border-r shadow-lg transition-transform duration-300 lg:translate-x-0 lg:static lg:z-auto",
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      )}>
        <div className="flex items-center justify-between h-16 px-4 border-b">
          <Link to="/dashboard" className="flex items-center space-x-2">
            <Flame className="h-6 w-6 text-primary" />
            <span className="text-lg font-semibold">Reheat</span>
          </Link>
          <Button variant="ghost" size="icon" onClick={() => setSidebarOpen(false)} className="lg:hidden">
            <X className="h-5 w-5" />
          </Button>
        </div>
        <nav className="flex flex-col gap-1 p-4">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                "flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md",
                location.pathname === item.href
                  ? "bg-secondary text-primary"
                  : "text-foreground/70 hover:bg-gray-50 hover:text-foreground"
              )}
            >
              <item.icon className="h-5 w-5" />
              {item.name}
            </Link>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t">
          <div className="flex items-center gap-3 px-3 py-2 rounded-full bg-gray-50">
            <User className="h-5 w-5 text-gray-500" />
            <span className="text-sm font-medium text-gray-700">Dealer Account</span>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-h-screen overflow-x-hidden">
        {/* Mobile header */}
        <header className="sticky top-0 z-30 flex items-center h-16 px-4 border-b bg-white lg:hidden">
          <Button variant="ghost" size="icon" onClick={() => setSidebarOpen(true)}>
            <Menu className="h-5 w-5" />
          </Button>
          <div className="flex items-center ml-4">
            <Flame className="h-5 w-5 text-primary mr-2" />
            <span className="font-semibold">Reheat</span>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 px-4 py-6 md:px-6 lg:px-8 bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
